import {createRoot} from 'react-dom/client';
import {StrictMode} from "react";
import BonusPointsList from "../components/bonus_points/BonusPointsList";
import BonusPointsEmpty from "../components/bonus_points/BonusPointsEmpty";

document.addEventListener('DOMContentLoaded', function () {
    const bonusPointsForm = document.getElementById('BonusPointsList');
    if (bonusPointsForm) {
        createRoot(bonusPointsForm).render(<StrictMode><BonusPointsList/></StrictMode>);
    } else {
        const bonusPointsEmpty = document.getElementById('BonusPointsEmpty');
        if (bonusPointsEmpty) {
            createRoot(bonusPointsEmpty).render(<StrictMode><BonusPointsEmpty/></StrictMode>);
        }
    }
})